const ACTOR_LABEL = {
  admin: "โดยแอดมิน",
  customer: "โดยลูกค้า",
  system: "โดยระบบ",
};

// Timeline องค์กร (แยกจาก Timeline ของ Product Set)
// action_type ตาม organization_action_log: 1 create, 2 update, 3 add member, 4 remove member, 5 ban booking, 6 unban booking
export const RENDER_ORGANIZATION_ACTION = (actionType) => {
  switch (String(actionType)) {
    case "1":
      return { label: "สร้างองค์กร", color: "#9e9e9e" };
    case "2":
      return { label: "แก้ไขข้อมูล", color: "#ef6c00" };
    case "3":
      return { label: "เพิ่มผู้ติดต่อ", color: "#2e7d32" };
    case "4":
      return { label: "ลบผู้ติดต่อ", color: "#c62828" };
    case "5":
      return { label: "ระงับการจอง", color: "#c62828" };
    case "6":
      return { label: "ยกเลิกการระงับการจอง", color: "#1565c0" };
    default:
      return { label: "ไม่ทราบสถานะ", color: "#9e9e9e" };
  }
};

// องค์กรที่สร้างก่อนมี log จะไม่มีรายการ "สร้างองค์กร" จึงเติมจาก created_at ให้ (ไม่ทราบผู้สร้าง)
export const RENDER_ORGANIZATION_TIMELINE = (organization, logs = []) => {
  const items = logs.map((e) => {
    const action = RENDER_ORGANIZATION_ACTION(e.action_type);
    const actor = ACTOR_LABEL[e.actor_type];
    return {
      key: e._id,
      label: actor ? `${action.label} ${actor}` : action.label,
      color: action.color,
      created_at: e.created_at,
      note: e.note,
    };
  });
  const hasCreateLog = logs.some((e) => String(e.action_type) === "1");
  if (!hasCreateLog && organization && organization.created_at) {
    const action = RENDER_ORGANIZATION_ACTION("1");
    items.unshift({
      key: "created",
      label: action.label,
      color: action.color,
      created_at: organization.created_at,
      note: "สร้างก่อนเริ่มบันทึกประวัติ จึงไม่มีข้อมูลผู้สร้าง",
    });
  }
  return items;
};

// ตัวเลือกส่วนกลางของ Set Code: ALL + Business Unit ที่ตั้งอักษรย่อแล้ว (ใช้แบ่งเลขรันเท่านั้น)
export const FETCH_BUSINESS_UNIT_OPTIONS = async (portalService) => {
  let res = await portalService.GET_BUSINESS_UNIT_LIST(
    `?pagination=false&is_delete=false`
  );
  return [
    { label: "ALL", value: "ALL" },
    ...(res && res.status === 200
      ? res.data.docs
          .filter((e) => e.short_name)
          .map((e) => ({ label: `${e.short_name} - ${e.name}`, value: e._id }))
      : []),
  ];
};

// แปลงข้อมูล product_warranty_set เป็นค่าเริ่มต้นของ CorperateProductSetForm
export const MAP_PRODUCT_SET_TO_FORM = (set) => ({
  ...set,
  slip_img: set.slip_img ? [{ media_uri: set.slip_img }] : [],
  product_warranty_list: (set.product_warranty_list || []).map((e) => ({
    info: {
      ...e,
      serial_no: e.name ? e.name.split("-")[0] : "",
      item_no: e.name ? e.name.split("-")[1] : "",
    },
  })),
});

// แปลงค่าฟอร์มเป็น FormData สำหรับ API corperate-product-set
export const MAP_PRODUCT_SET_FORM_TO_FORMDATA = (values, { isCreate } = {}) => {
  const formData = new FormData();
  formData.append("name", values.name || "");
  formData.append("note", values.note || "");
  if (isCreate) {
    formData.append("organization_ref_id", values.organization_ref_id);
    formData.append("business_unit_ref_id", values.business_unit_ref_id || "ALL");
  } else {
    if (values.warranty_method) {
      formData.append("warranty_method", values.warranty_method);
    }
    if (values.warranty_config) {
      formData.append("warranty_config", JSON.stringify(values.warranty_config));
    }
    if (values.warranty_group_config) {
      formData.append(
        "warranty_group_config",
        JSON.stringify(values.warranty_group_config)
      );
    }
  }
  const productWarrantyIds = (values.product_warranty_list || [])
    .map((e) => e && e.info && (e.info.product_warranty_id || e.info._id))
    .filter((e) => e);
  formData.append(
    "product_warranty_list",
    JSON.stringify(
      [...new Set(productWarrantyIds)].map((e) => ({ product_warranty_id: e }))
    )
  );
  const newSlip = (values.slip_img || []).find((e) => e && e.isNewUpload);
  if (newSlip) formData.append("image", newSlip);
  return formData;
};

// Timeline ของ Product Set: action_type 1 create, 2 save draft, 3 sent to approve, 4 approve, 5 reject, 6 update
export const RENDER_PRODUCT_SET_ACTION = (actionType) => {
  switch (String(actionType)) {
    case "1":
      return { label: "Create Set", color: "#9e9e9e" };
    case "2":
      return { label: "Save Draft", color: "#ffb341" };
    case "3":
      return { label: "Pending to Approve", color: "#ef6c00" };
    case "4":
      return { label: "Approve", color: "#2e7d32" };
    case "5":
      return { label: "Reject", color: "#c62828" };
    case "6":
      return { label: "แก้ไขข้อมูลก่อนอนุมัติ", color: "#4b1e78" };
    default:
      return { label: "ไม่ทราบสถานะ", color: "#9e9e9e" };
  }
};

export const RENDER_PRODUCT_SET_TIMELINE = (logs = []) =>
  logs.map((e) => {
    const action = RENDER_PRODUCT_SET_ACTION(e.action_type);
    const actor = ACTOR_LABEL[e.actor_type];
    return {
      key: e._id,
      label: actor ? `${action.label} ${actor}` : action.label,
      color: action.color,
      created_at: e.created_at,
      note: e.note,
    };
  });
